import { render, staticRenderFns } from "./NoMoreData.vue?vue&type=template&id=5d5ce290&scoped=true"
import script from "./no_more_data.js?vue&type=script&lang=js&external"
export * from "./no_more_data.js?vue&type=script&lang=js&external"
import style0 from "./no_more_data.scss?vue&type=style&index=0&id=5d5ce290&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5ce290",
  null
  
)

export default component.exports